import React from 'react';
import baseComponent from '../../decorators/baseComponent';
import styles from './ProgressButton.scss';
import BaseReactComponent from '../Util/BaseReactComponent';
import classNames from 'classnames';

@baseComponent(styles) class ProgressButton extends BaseReactComponent {
  render() {
    var classes = classNames({
      'center-block': this.props.centerBlock,
      'waves-effect': true,
      'btn': true,
      'btn-primary': true,
      'ProgressButton': true,
      'processing': this.props.inprogress,
      'right': this.props.right
    });

    return (
      <a className={classes} onClick={this.props.onClick}>
        {this.props.saving ? undefined : this.props.children}
        <svg className="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
          <circle className="path" fill="none" strokeWidth="6" strokeLinecap="round" cx="33" cy="33" r="30"></circle>
        </svg>
      </a>
    );
  }
}

ProgressButton.propTypes = {
  inprogress: React.PropTypes.bool,
  right: React.PropTypes.bool
};
ProgressButton.defaultProps = {
  inprogress: false,
  right: false,
  centerBlock: true
};

export default ProgressButton;



// WEBPACK FOOTER //
// /src/components/ProgressButton/ProgressButton.js